import { createContext } from "react";

export const rootContexts= createContext();